import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

import { GET_DISCOUNTED_PRICES } from 'hooks/queries/useGetDiscountedPrices';

import { MONTHLY_TERM, YEARLY_TERM } from '../../constants';
import { buildPackagePricesByTerm } from '../../utils';

export const useOrgPricing = () => {
  const {
    data,
    error: orgPricesError,
    loading,
  } = useQuery(GET_DISCOUNTED_PRICES);

  const orgPricePackages = useMemo(() => {
    const orgPrices = data?.getDiscountedPrices || [];
    return buildPackagePricesByTerm([...orgPrices]) || {};
  }, [data]);

  return useMemo(() => {
    const monthlyPackagePrices = orgPricePackages[MONTHLY_TERM];
    const yearlyPackagePrices = orgPricePackages[YEARLY_TERM];

    return {
      loading,
      monthlyPackagePrices,
      orgPricePackages,
      orgPricesError,
      yearlyPackagePrices,
    };
  }, [loading, orgPricesError, orgPricePackages]);
};
